import * as Yup from "yup";

export const paymentValidations = () => {
  const addressSchema = Yup.object().shape({
    city: Yup.string().required("Campo obrigatório"),
    neighborhood: Yup.string().required("Campo obrigatório"),
    state: Yup.string().required("Campo obrigatório"),
    street: Yup.string().required("Campo obrigatório"),
    street_number: Yup.string().required("Campo obrigatório"),
    zipcode: Yup.string().required("Campo obrigatório"),
  });

  const billingInformationSchema = Yup.object().shape({
    address: addressSchema,
  });

  const creditCardListSchema = Yup.object().shape({
    credit_card_list: Yup.object().shape({
      card_id: Yup.string().required("Selecione um cartão"),
    }),
  });

  const creditCardFormSchema = Yup.object().shape({
    credit_card_form: Yup.object().shape({
      card_cvv: Yup.string().required("Obrigatório"),
      card_number: Yup.string().required("Campo obrigatório"),
      card_expiration_date: Yup.string().required("Obrigatório"),
      card_holder_name: Yup.string().required("Campo obrigatório"),
    }),
  });

  return {
    billingInformationSchema,
    creditCardFormSchema,
    creditCardListSchema,
    addressSchema,
  };
};
